module.exports = __webpack_public_path__ + "img/member_rights_icon_435001.32eeb20a.png";